import React, { Component, Fragment } from 'react';
import moment from 'moment';
import momentLocalizer from 'react-widgets-moment';
import { DateTimePicker } from 'react-widgets';
import 'react-widgets/dist/css/react-widgets.css';
import axios from 'axios';

const headers = {
    'X-CSRF-TOKEN': window.session.token,
    'credentials': 'same-origin',
    "Content-Type": "application/json",
    "Accept": "application/json",
    "X-Requested-With": "XMLHttpRequest"
}

export default class FutureOrderSelector extends Component {
    constructor(props) {
        super(props);
        this.state = {
            deferDateTime: null,
            okButtonDisabled: true,
            possible_dates: [],
            possible_hours: [],
            selected_date: null,
            selected_hour: null,
            selected_minute: session.deferred_increments[0],
            hour_selection_locked: false,
            error_text: null
        };
        this.defer = this.defer.bind(this);
        this.getPossibleDates = this.getPossibleDates.bind(this);
        this.handleDateSelected = this.handleDateSelected.bind(this);
        this.handleFutureOkPressed = this.handleFutureOkPressed.bind(this);
        this.handleHourSelected = this.handleHourSelected.bind(this);
        this.handleMinuteSelected = this.handleMinuteSelected.bind(this);
    }

    defer() {
        this.props.closeFutureOrderSelector();
    }

    get_open_time(st,dow)
    {
        if(st === 'delivery')
        {
            switch (dow)
            {
                case 'Monday':
                    if(moment(this.state.deferDateTime).format('llll').includes('AM')) {
                        return moment(this.state.deferDateTime).subtract(1,'day').format('ll') + ' ' + session.delivery_hours.sunday_hours.open;
                    }
                    return moment(this.state.deferDateTime).format('ll') + ' ' + session.delivery_hours.monday_hours.open;
                    break;
                case 'Tuesday':
                    if(moment(this.state.deferDateTime).format('llll').includes('AM')) {
                        return moment(this.state.deferDateTime).subtract(1,'day').format('ll') + ' ' + session.delivery_hours.monday_hours.open;
                    }
                    return moment(this.state.deferDateTime).format('ll') + ' ' + session.delivery_hours.tuesday_hours.open;
                    break;
                case 'Wednesday':
                    if(moment(this.state.deferDateTime).format('llll').includes('AM')) {
                        return moment(this.state.deferDateTime).subtract(1,'day').format('ll') + ' ' + session.delivery_hours.tuesday_hours.open;
                    }
                    return moment(this.state.deferDateTime).format('ll') + ' ' + session.delivery_hours.wednesday_hours.open;
                    break;
                case 'Thursday':
                    if(moment(this.state.deferDateTime).format('llll').includes('AM')) {
                        return moment(this.state.deferDateTime).subtract(1,'day').format('ll') + ' ' + session.delivery_hours.wednesday_hours.open;
                    }
                    return moment(this.state.deferDateTime).format('ll') + ' ' + session.delivery_hours.thursday_hours.open;
                    break;
                case 'Friday':
                    if(moment(this.state.deferDateTime).format('llll').includes('AM')) {
                        return moment(this.state.deferDateTime).subtract(1,'day').format('ll') + ' ' + session.delivery_hours.thursday_hours.open;
                    }
                    return moment(this.state.deferDateTime).format('ll') + ' ' + session.delivery_hours.friday_hours.open;
                    break;
                case 'Saturday':
                    if(moment(this.state.deferDateTime).format('llll').includes('AM')) {
                        return moment(this.state.deferDateTime).subtract(1,'day').format('ll') + ' ' + session.delivery_hours.friday_hours.open;
                    }
                    return moment(this.state.deferDateTime).format('ll') + ' ' + session.delivery_hours.saturday_hours.open;
                    break;
                case 'Sunday':
                    if(moment(this.state.deferDateTime).format('llll').includes('AM')) {
                        return moment(this.state.deferDateTime).subtract(1,'day').format('ll') + ' ' + session.delivery_hours.saturday_hours.open;
                    }
                    return moment(this.state.deferDateTime).format('ll') + ' ' + session.delivery_hours.sunday_hours.open;
                    break;
                default:
                    return false;
            }
        }
        else
        {
            switch (dow)
            {
                case 'Monday':
                    if(moment(this.state.deferDateTime).format('llll').includes('AM')) {
                        return moment(this.state.deferDateTime).subtract(1,'day').format('ll') + ' ' + session.delivery_hours.sunday_hours.open;
                    }
                    return moment(this.state.deferDateTime).format('ll') + ' ' + session.pickup_hours.monday_hours.open;
                    break;
                case 'Tuesday':
                    if(moment(this.state.deferDateTime).format('llll').includes('AM')) {
                        return moment(this.state.deferDateTime).subtract(1,'day').format('ll') + ' ' + session.delivery_hours.monday_hours.open;
                    }
                    return moment(this.state.deferDateTime).format('ll') + ' ' + session.pickup_hours.tuesday_hours.open;
                    break;
                case 'Wednesday':
                    if(moment(this.state.deferDateTime).format('llll').includes('AM')) {
                        return moment(this.state.deferDateTime).subtract(1,'day').format('ll') + ' ' + session.delivery_hours.tuesday_hours.open;
                    }
                    return moment(this.state.deferDateTime).format('ll') + ' ' + session.pickup_hours.wednesday_hours.open;
                    break;
                case 'Thursday':
                    if(moment(this.state.deferDateTime).format('llll').includes('AM')) {
                        return moment(this.state.deferDateTime).subtract(1,'day').format('ll') + ' ' + session.delivery_hours.wednesday_hours.open;
                    }
                    return moment(this.state.deferDateTime).format('ll') + ' ' + session.pickup_hours.thursday_hours.open;
                    break;
                case 'Friday':
                    if(moment(this.state.deferDateTime).format('llll').includes('AM')) {
                        return moment(this.state.deferDateTime).subtract(1,'day').format('ll') + ' ' + session.delivery_hours.thursday_hours.open;
                    }
                    return moment(this.state.deferDateTime).format('ll') + ' ' + session.pickup_hours.friday_hours.open;
                    break;
                case 'Saturday':
                    if(moment(this.state.deferDateTime).format('llll').includes('AM')) {
                        return moment(this.state.deferDateTime).subtract(1,'day').format('ll') + ' ' + session.delivery_hours.friday_hours.open;
                    }
                    return moment(this.state.deferDateTime).format('ll') + ' ' + session.pickup_hours.saturday_hours.open;
                    break;
                case 'Sunday':
                    if(moment(this.state.deferDateTime).format('llll').includes('AM')) {
                        return moment(this.state.deferDateTime).subtract(1,'day').format('ll') + ' ' + session.delivery_hours.saturday_hours.open;
                    }
                    return moment(this.state.deferDateTime).format('ll') + ' ' + session.pickup_hours.sunday_hours.open;
                    break;
                default:
                    return false;
            }
        }
    }

    get_close_time(st,dow)
    {
        if(st === 'delivery')
        {
            switch (dow)
            {
                case 'Monday':
                    if(moment(this.state.deferDateTime).format('llll').includes('AM')) {
                        return moment(this.state.deferDateTime).format('ll') + ' ' + session.delivery_hours.sunday_hours.close;
                    }
                    return moment(this.state.deferDateTime).format('ll') + ' ' + session.delivery_hours.monday_hours.close;
                    break;
                case 'Tuesday':
                    if(moment(this.state.deferDateTime).format('llll').includes('AM')) {
                        console.log('happens');
                        return moment(this.state.deferDateTime).format('ll') + ' ' + session.delivery_hours.monday_hours.close;
                    }
                    return moment(this.state.deferDateTime).format('ll') + ' ' + session.delivery_hours.tuesday_hours.close;
                    break;
                case 'Wednesday':
                    if(moment(this.state.deferDateTime).format('llll').includes('AM')) {
                        return moment(this.state.deferDateTime).format('ll') + ' ' + session.delivery_hours.tuesday_hours.close;
                    }
                    return moment(this.state.deferDateTime).format('ll') + ' ' + session.delivery_hours.wednesday_hours.close;
                    break;
                case 'Thursday':
                    if(moment(this.state.deferDateTime).format('llll').includes('AM')) {
                        return moment(this.state.deferDateTime).format('ll') + ' ' + session.delivery_hours.wednesday_hours.close;
                    }
                    return moment(this.state.deferDateTime).format('ll') + ' ' + session.delivery_hours.thursday_hours.close;
                    break;
                case 'Friday':
                    if(moment(this.state.deferDateTime).format('llll').includes('AM')) {
                        return moment(this.state.deferDateTime).format('ll') + ' ' + session.delivery_hours.thursday_hours.close;
                    }
                    return moment(this.state.deferDateTime).format('ll') + ' ' + session.delivery_hours.friday_hours.close;
                    break;
                case 'Saturday':
                    if(moment(this.state.deferDateTime).format('llll').includes('AM')) {
                        return moment(this.state.deferDateTime).format('ll') + ' ' + session.delivery_hours.friday_hours.close;
                    }
                    return moment(this.state.deferDateTime).format('ll') + ' ' + session.delivery_hours.saturday_hours.close;
                    break;
                case 'Sunday':
                    if(moment(this.state.deferDateTime).format('llll').includes('AM')) {
                        return moment(this.state.deferDateTime).format('ll') + ' ' + session.delivery_hours.saturday_hours.close;
                    }
                    return moment(this.state.deferDateTime).format('ll') + ' ' + session.delivery_hours.sunday_hours.close;
                    break;
                default:
                    return false;
            }
        }
        else
        {
            switch (dow)
            {
                case 'Monday':
                    if(moment(this.state.deferDateTime).format('llll').includes('AM')) {
                        return moment(this.state.deferDateTime).format('ll') + ' ' + session.pickup_hours.sunday_hours.close;
                    }
                    return moment(this.state.deferDateTime).format('ll') + ' ' + session.pickup_hours.monday_hours.close;
                    break;
                case 'Tuesday':
                    if(moment(this.state.deferDateTime).format('llll').includes('AM')) {
                        console.log(moment(this.state.deferDateTime).format('ll') + ' ' + session.pickup_hours.monday_hours.close)
                        return moment(this.state.deferDateTime).format('ll') + ' ' + session.pickup_hours.monday_hours.close;
                    }
                    return moment(this.state.deferDateTime).format('ll') + ' ' + session.pickup_hours.tuesday_hours.close;
                    break;
                case 'Wednesday':
                    if(moment(this.state.deferDateTime).format('llll').includes('AM')) {
                        return moment(this.state.deferDateTime).format('ll') + ' ' + session.pickup_hours.tuesday_hours.close;
                    }
                    return moment(this.state.deferDateTime).format('ll') + ' ' + session.pickup_hours.wednesday_hours.close;
                    break;
                case 'Thursday':
                    if(moment(this.state.deferDateTime).format('llll').includes('AM')) {
                        return moment(this.state.deferDateTime).format('ll') + ' ' + session.pickup_hours.wednesday_hours.close;
                    }
                    return moment(this.state.deferDateTime).format('ll') + ' ' + session.pickup_hours.thursday_hours.close;
                    break;
                case 'Friday':
                    if(moment(this.state.deferDateTime).format('llll').includes('AM')) {
                        return moment(this.state.deferDateTime).format('ll') + ' ' + session.pickup_hours.thursday_hours.close;
                    }
                    return moment(this.state.deferDateTime).format('ll') + ' ' + session.pickup_hours.friday_hours.close;
                    break;
                case 'Saturday':
                    if(moment(this.state.deferDateTime).format('llll').includes('AM')) {
                        return moment(this.state.deferDateTime).format('ll') + ' ' + session.pickup_hours.friday_hours.close;
                    }
                    return moment(this.state.deferDateTime).format('ll') + ' ' + session.pickup_hours.saturday_hours.close;
                    break;
                case 'Sunday':
                    if(moment(this.state.deferDateTime).format('llll').includes('AM')) {
                        return moment(this.state.deferDateTime).format('ll') + ' ' + session.pickup_hours.saturday_hours.close;
                    }
                    return moment(this.state.deferDateTime).format('ll') + ' ' + session.pickup_hours.sunday_hours.close;
                    break;
                default:
                    return false;
            }
        }
    }

    service_type_wait_time(current_st)
    {
        if(current_st === 'delivery')
        {
            return session.delivery_wait_time;
        }
        else
        {
            return session.pickup_wait_time;
        }
    }

    generate_deferred_error(error_text)
    {
        let error_message = document.getElementById("error_text");
        error_message.classList.add("p-2");
        document.getElementById("error_text").innerHTML = error_text;
        this.setState({
            error_text: error_text
        })
    }

    getPossibleDates() {
        let _this = this;
        let url = `${window.relativeURI()}/store/deferred/dates`;
        axios.post(url, {
            headers: headers,
            service_type_id: _this.props.selectedServiceType.id
        })
        .then(function (response) {
            _this.setState({
                possible_hours: response.data.first_date_hours,
                possible_dates: response.data.dates,
                selected_date: response.data.first_date,
                selected_hour: response.data.first_hour
            })
        })
        .catch(function (error) {
            console.log(error);
        })
        .finally(function () {
            // always executed
        });
    }

    handleDateSelected(e) {
        let _this = this;
        _this.setState({
            hour_selection_locked: true,
            selected_date: e.target.value
        });
        let url = `${window.relativeURI()}/store/deferred/hours`;
        axios.post(url, {
            headers: headers,
            deferred_date: e.target.value,
            service_type_id: _this.props.selectedServiceType.id
        })
            .then(function (response) {
                _this.setState({
                    possible_hours: response.data.hours,
                    hour_selection_locked: false
                })
            })
            .catch(function (error) {
                console.log(error);
            })
            .finally(function () {
                // always executed
            });
    }

    handleHourSelected(e) {
        this.setState({
            selected_hour: e.target.value
        })
    }

    handleMinuteSelected(e) {
        this.setState({
            selected_minute: e.target.value
        })
    }

    handleFutureOkPressed() {
        //do a little trickery to replace the selected hours minute
        console.log(this.state.selected_hour)
        let orig_hour_string = this.state.selected_hour;
        let hour_string = this.state.selected_hour.replace(' AM', '').replace(' PM', '');
        let hour_string_as_array = hour_string.split(':');
        let new_hour_string = orig_hour_string.replace(hour_string_as_array[1], this.state.selected_minute)
        this.setState({
            selected_hour: new_hour_string
        }, () => {
            //now we can send this data to the backend for processing.
            let _this = this;
            let url = `${window.relativeURI()}/store/deferred/check`;
            axios.post(url, {
                service_type_id: _this.props.selectedServiceType.id,
                date_to_check: `${_this.state.selected_date} ${_this.state.selected_hour}`
            })
                .then(function (response) {
                    _this.props.handleFutureTimeChosen();
                })
                .catch(function (error) {
                    _this.setState({
                        error_text: error.response.data.message
                    })
                })
                .finally(function () {
                    // always executed
                });
        })
    }

    componentDidMount() {
        this.getPossibleDates();
    }

    render() {
        return(
            <div className='cart-address-selector'>
                {
                    this.props.showSelector ? (
                        <div className='pt-2 text-center'>
                            <h5>Select a date and time.</h5>
                            <div className={"form-group"}>
                                <div className={"row"}>
                                    <div className={"col-12"}>
                                        <label htmlFor="dateSelect">Date</label>
                                        <select className="form-control" id="dateSelect" onChange={this.handleDateSelected}>
                                            {
                                                this.state.possible_dates.map((date, i) => {
                                                    return <option key={i} value={date}>{date}</option>
                                                })
                                            }
                                        </select>
                                    </div>
                                    <div className={"col-6"}>
                                        <label htmlFor="hourSelect">Hour</label>
                                        <select className={`form-control`} id="hourSelect" onChange={this.handleHourSelected} disabled={this.state.hour_selection_locked}>
                                            {
                                                this.state.possible_hours.map((hour, i) => {
                                                    return <option key={i} value={hour}>{hour}</option>
                                                })
                                            }
                                        </select>
                                    </div>
                                    <div className={"col-6"}>
                                        <label htmlFor="minuteSelect">Minute</label>
                                        <select className="form-control" id="minuteSelect" onChange={this.handleMinuteSelected}>
                                            {
                                                session.deferred_increments.map((increment, i) => {
                                                    return <option key={i} value={increment}>{increment}</option>
                                                })
                                            }
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div className="m-2">
                                <p id='error_text' />
                            </div>
                            {
                                this.state.error_text &&
                                <div className="alert alert-danger" role="alert">
                                    {this.state.error_text}
                                </div>
                            }
                            <button className="btn btn-primary m-1" onClick={this.props.handleBackOnFutureTimePressed}>Back</button>
                            <button className="btn btn-primary m-1 " onClick={this.handleFutureOkPressed}>OK</button>
                        </div>
                    ) : this.props.isFutureOrder ?  // Generate prompt or display future order time
                        (
                            <div className='text-center'>
                                <h5>Your order has been deferred</h5>
                                <p className='ml-5'>This order is being placed for <span className='store-fg-primary text-medium'>{this.props.futureOrderDate.format('dddd MMM Do')}</span> at <span className='store-fg-primary text-medium'>{this.props.futureOrderTime.format('h:mm A')}</span></p>
                                <div data-role='buttongroup'>
                                    <button className='btn btn-primary m-3' onClick={this.props.promptForFutureOrders}>Change Timing</button>
                                    <button className='btn btn-secondary m-3' onClick={this.props.asapPressed}>Place for ASAP</button>
                                </div>
                            </div>
                        ): (
                            <div className='mt-2 text-center'>
                                <h5>Please select an order time.</h5>
                                <button className='btn btn-primary m-1' onClick={this.props.asapPressed}>ASAP</button>
                                {session.store.future_order_days > 0 && <button className='btn btn-primary m-1' onClick={this.props.promptForFutureOrders}>Future Time/Date</button>}
                            </div>
                        )
                }
            </div>
        )
    }
}
